import { render } from "./CartPanel_Culinary.vue?vue&type=template&id=a809c4f0&scoped=true"
import script from "./CartPanel_Culinary.vue?vue&type=script&lang=js"
export * from "./CartPanel_Culinary.vue?vue&type=script&lang=js"

import "./CartPanel_Culinary.vue?vue&type=style&index=0&id=a809c4f0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a809c4f0"]])

export default __exports__